module.exports = __webpack_public_path__ + "static/media/hackathon1.7a2dbf7a.svg";